export async function loadTextFromFile({ fileName, dir }) {
    const url = `${process.env.PUBLIC_URL}/texts/${dir}/${fileName}`;

    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to load "${fileName}" (status ${response.status})`);  
    }

    return await response.text();
}
